import { render, staticRenderFns } from "./MisSugerenciasPage.vue?vue&type=template&id=2584c363&scoped=true"
import script from "./MisSugerenciasPage.js?vue&type=script&lang=js&external"
export * from "./MisSugerenciasPage.js?vue&type=script&lang=js&external"
import style0 from "./MisSugerenciasPage.vue?vue&type=style&index=0&id=2584c363&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2584c363",
  null
  
)

export default component.exports